import React from 'react'
import './SemiCircularBar.css'

function SemiCircularBar(props) {
  return (
    <div className="progress">
      <div className="barOverflow">
        <div
          className="bar"
          style={
            props.status === 'Failed'
              ? { transform: 'rotate(' + (45 + 50 * 1.8) + 'deg)' }
              : { transform: 'rotate(' + (45 + 50 * -1.8) + 'deg)' }
          }
        ></div>
      </div>
      <div className="status">{props?.statusName}</div>
      <div>{props?.title}</div>
    </div>
  )
}

export default SemiCircularBar
